import React from "react";
import Modal from "react-responsive-modal"; // or your modal library
// import progresscart from "../assets/progresscart.png"; // adjust path as per your project
import { useHistory } from "react-router-dom";
import './NoAddressModal.scss'

const NoAddressModal = ({ open, onClose, t }) => {
  const history = useHistory();

  return (
    <Modal
      open={open}
      classNames={{
        overlay: "customOverlay",
        modal: "customModal__placeorder",
      }}
      onClose={onClose}
    >
      <div
        className={`summary__placeorder ${
          localStorage.getItem("storeid") == 1 ? "englang" : "thailang"
        }`}
      >
        {/* <img src={progresscart} alt="" /> */}
        <p className="placeorder__content">
          {t("You don’t have any delivery address added yet. Please add one to continue.")}
        </p>

        <p className="placeorder__button">
          <span
            className="placeorder__accept"
            onClick={() => {
              onClose();
              history.push("/myaccount/deliveryaddress");
            }}
          >
            {t("Ok")}
          </span>
          <span
            className="placeorder__cancel"
            onClick={onClose}
          >
            {t("Cancel")}
          </span>
        </p>
      </div>
    </Modal>
  );
};

export default NoAddressModal;
